export default {
  namespaced: true,
  state: {
    input_text: '',
  },
  getters: {
    getSearchBarInputText(state) {
      return state.input_text
    },
  },
  mutations: {
    setSearchBarInputText(state, val) {
      state.input_text = val
    },
  },
  actions: {
    setSearchBarInputs({ commit }, value) {
      commit('setSearchBarInputText', value)
    },
  },
}
